import type * as MessageCards from '../types/MessageCards'
import { imageParser } from '../props/parsers/Image'

export default function messageCardsComponentParser(
  rawComponent: MessageCards.Raw,
): MessageCards.Parsed {
  const { cards, settings } = rawComponent.messageCards

  const showNumber = settings.showHideNumber !== 'hide'
  const isGradient = settings.isGradient !== 'false'

  return {
    name: 'MessageCards',
    props: {
      messages: cards.map((card) => {
        const { bodyText, headlineText, image } = card

        return {
          bodyText,
          headlineText,
          showNumber,
          rulerColor: settings.rulerColor,
          variant: settings.variant,
          ...imageParser(image),
          isGradient,
        }
      }),
    },
  }
}
